<template>
  <div v-if="ctx" class="flow-directory">
    <button type="button" class="toggle" :aria-expanded="open" @click="open = !open">{{ open ? '收起' : (canEdit ? '编辑' : '查看') }}本站{{ name }}列表</button>
    <small>列表来自「站点业务目录」，新增、改名或停用无需修改流程，只影响本站，保存后新会话生效。</small>
    <AiBusinessDirectory v-if="open" :site="ctx.site" :can-edit="canEdit" :fixed-type="type" @saved="ctx.refreshFlow()" />
  </div>
</template>
<script setup>
/* global defineProps */
// 流程条件的值来自站点业务目录（例如优惠类别）时，直接在流程页编辑该目录；目录编辑器按需载入
import { computed, defineAsyncComponent, inject, ref } from 'vue'
const AiBusinessDirectory = defineAsyncComponent(() => import('./AiBusinessDirectory.vue'))
const props = defineProps({ type: { type: String, required: true } })
const ctx = inject('flowReplyEditing', null)
const open = ref(false)
const canEdit = computed(() => Boolean(ctx?.canEditFlow || ctx?.canEditDirectory))
const name = computed(() => ({ promotions: '优惠', downloads: '软件', withdrawalMethods: '提款方式' }[props.type] || ''))
</script>
<style scoped>
.flow-directory { margin:8px 0 12px; }
.toggle { padding:6px 12px; background:#fff7ed; border:1px solid #fed7aa; border-radius:7px; color:#b45309; cursor:pointer; }
small { display:block; margin-top:6px; color:#64748b; font-size:12px; }
</style>
